import React, { useRef } from 'react';
import { Select } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';

const { Option } = Select;

const AccessibleSelect = ({
                              value,
                              onChange,
                              placeholder = 'Select an option',
                              options = [],
                              ...props
                          }) => {
    const selectRef = useRef();

    const handleClear = () => {
        onChange?.(undefined);
        selectRef.current?.focus?.();
    };

    return (
        <>
            <Select
                {...props}
                ref={selectRef}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                allowClear={false}
                getPopupContainer={trigger => trigger.parentElement}
            >
                {options.map(({ label, value }) => (
                    <Option key={value} value={value}>
                        {label}
                    </Option>
                ))}
            </Select>

            {value !== undefined && value !== null && (
                <button
                    type="button"
                    className="ch-accessible-clear-button"
                    aria-label="Clear selected option"
                    tabIndex={0}
                    onClick={handleClear}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        border: 'none',
                        padding: 0,
                        marginLeft: 'var(--spacing-unit)',
                        cursor: 'pointer',
                        fontSize: 20,
                    }}
                >
                    <CloseCircleFilled aria-hidden="true" />
                </button>
            )}
        </>
    );
};

export default AccessibleSelect;
